import { tWithKeyAttr as t } from "../../i18nHelper";
import React, { ReactNode, useEffect, useState } from "react";
import { Category } from "../../types/types";
import useMediaQuery from "../../hooks/useMediaQuery";
import styles from "./mainContentLayout.module.css";
import Sidebar from "../sidebar/sidebar";
import Notifications from "../notifications/notifications";
import { mobileWidth } from "../../utils/constants";
import ModalOverlay from "../modals/modalOverlay/ModalOverlay";
import { menuCategories } from "../../utils/categories";
import i18n from "../../i18n";
import { useAppSelector } from "../../services/hooks";
import { isMultiCompanySelector } from "../../services/selectors/user.selectors";
import CompaniesCombo from "../companiesCombo/CompaniesCombo";


interface IMainContentLayoutProps {
  activeCategory: Category;
  changeCategory: (e: React.MouseEvent, cat: Category) => void;
  children: ReactNode;
}

function MainContentLayout({
  activeCategory,
  changeCategory,
  children,
}: IMainContentLayoutProps) {
  const mobile = useMediaQuery(mobileWidth);
  const initialState = !mobile;
  const [openMenu, setOpenMenu] = useState(initialState);
  const [showNotifications, setShowNotifications] = useState(false);
  const isMulti = useAppSelector(isMultiCompanySelector);
  const toggleMenu = () => {
    setOpenMenu(!openMenu);
  };
  const hideNotifications = () => {
    if (showNotifications) setShowNotifications(false);
  };

  return (
    <main
      className={`${styles.main}
        ${!openMenu && styles.main_small} `}
      data-testid="main-content-layout"
      dir={i18n.dir()}
    >
      {mobile && openMenu && (
        <ModalOverlay onClick={() => setOpenMenu(false)} />
      )}
      <Sidebar
        openMenu={openMenu}
        toggleMenu={toggleMenu}
        changeCategory={changeCategory}
        activeCategory={activeCategory}
      />
      <section className={`${styles.mainContent}`} onClick={hideNotifications} data-scroll-container>
        <Notifications showNotifications={showNotifications} />
        <div className={`${styles.header}`}>
          <h1 className={`${styles.mainContent__title}`}>
            {t(menuCategories[activeCategory])}
          </h1>
          {isMulti
            && <CompaniesCombo />}
          {/*<button*/}
          {/*  className={`${styles.mainContent__bell} ${*/}
          {/*    (showNotifications || !mobile) &&*/}
          {/*    styles.mainContent__bell_invisible*/}
          {/*  }`}*/}
          {/*  onClick={() => {*/}
          {/*    setShowNotifications(!showNotifications);*/}
          {/*  }}*/}
          {/*/>*/}
          <button
            type="button"
            onClick={toggleMenu}
            className={styles.burger}
          />
        </div>
        {children}
      </section>



    </main>
  );
}
export default MainContentLayout;
